// tslint:disable-next-line:interface-name
export interface Iv3NavStates {
  [propName: string]: {
    humanName: string;
    isActiveState: string;
    goState: string;
    isRestricted: boolean;
    flagCount: number;
  };
}
export const v3NavStates = {
  v3: {
    MY_STUDENTS_LIST: {
      humanName: 'My Students',
      isActiveState: 'main.school.lists.my-students-list',
      goState: 'main.school.lists.my-students-list',
      isRestricted: null,
      flagCount: null,
    },
    ATTENDANCE_LIST: {
      humanName: 'Attendance',
      isActiveState: 'main.school.lists.attendance-list',
      goState: 'main.school.lists.attendance-list',
      isRestricted: null,
      flagCount: null,
    },
    ACADEMIC_LIST: {
      humanName: 'Academic',
      isActiveState: 'main.school.lists.academic-list',
      goState: 'main.school.lists.academic-list',
      isRestricted: null,
      flagCount: null,
    },
  },

  v2: {
    GRAD_PLANS: {
      humanName: 'Grad plans',
      sdcStateRoot: 'main.school.new-sdc.grad-planning',
      isActiveState: 'main.school.new-sdc.grad-planning.wizard',
      goState: 'main.school.new-sdc.grad-planning.wizard',
      isRestricted: null,
    },
    CREDIT_GAPS: {
      humanName: 'Credit gaps',
      sdcStateRoot: 'main.school.new-sdc.credit-gaps',
      isActiveState: 'main.school.new-sdc.credit-gaps.wizard',
      goState: 'main.school.new-sdc.credit-gaps.wizard',
      isRestricted: null,
    },
    REGENTS_PLANNING: {
      humanName: 'Regents planning',
      sdcStateRoot: 'main.school.new-sdc.regents-planning',
      isActiveState: 'main.school.new-sdc.regents-planning.wizard',
      goState: 'main.school.new-sdc.regents-planning.wizard',
      isRestricted: null,
    },
    REGENTS_PREP: {
      humanName: 'Regents prep',
      sdcStateRoot: 'main.school.new-sdc.regents-prep',
      isActiveState: 'main.school.new-sdc.regents-prep.wizard',
      goState: 'main.school.new-sdc.regents-prep.wizard',
      isRestricted: null,
    },
    OTHER_TOOLS: {
      humanName: 'Other Tools',
      sdcStateRoot: null,
      isActiveState: 'main.school.tools',
      goState: 'main.school.tools',
      isRestricted: null,
    },
    DEFAULT_SDC_GRID: {
      humanName: 'Data grid',
      sdcStateRoot: 'main.school.new-sdc.default-sdc.grid',
      isActiveState: 'main.school.new-sdc.default-sdc.grid',
      goState: 'main.school.new-sdc.default-sdc.grid',
      isRestricted: null,
    },
    ATTENDANCE: {
      humanName: 'Attendance',
      sdcStateRoot: 'main.school.new-sdc.attendance.grid',
      isActiveState: 'main.school.new-sdc.attendance.grid',
      goState: 'main.school.new-sdc.attendance.grid',
      isRestricted: null,
    },
    MARKING_PERIOD: {
      humanName: 'Marking Period',
      sdcStateRoot: 'main.school.new-sdc.marking-period.grid',
      isActiveState: 'main.school.new-sdc.marking-period.grid',
      goState: 'main.school.new-sdc.marking-period.grid',
      isRestricted: null,
    },
  },
};
